import { SystemUsageDto } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import { useCallback, useState } from 'react';

const CACHE_TIME = 60000; //1min

export function useSystemUsages() {

  const api = useCoreApi();
  const [isChecking, setIsChecking] = useState(false);
  const [lastCheck, setLastCheck] = useState<number | null>(null);
  const [limits, setLimits] = useState<SystemUsageDto>();

  const checkLimits = useCallback(async (forceRefresh = false): Promise<SystemUsageDto | null> => {

    if (isChecking) return null;

    var now = Date.now();
    const diffInMs = now - (lastCheck ?? 0);
    if (!forceRefresh && lastCheck && (diffInMs < CACHE_TIME)) {
      return null;
    }

    try {
      setIsChecking(true);
      var response = await api.v1.system.checkSystemUsages();
      setLimits(response.data);
      setLastCheck(Date.now());

      return response.data;
    }
    catch (error) {
      console.error('Erro ao verificar limites de uso:', error);

      return null;
    }
    finally {
      setIsChecking(false);
    }


  }, []);

  // useEffect(() => {
  //   checkLimits();
  // }, [checkLimits]);

  return { checkLimit: checkLimits, isChecking, limits };
}
